var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c("GeneralEditForm", {
            ref: "GeneralEditForm",
            attrs: {
              columns: _vm.editColumns,
              "edit-form": _vm.editForm,
              rules: _vm.fullRules,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", { staticStyle: { "margin-bottom": "0px" } }),
      _vm._v(" "),
      _c("el-row", { attrs: { width: "100%" } }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              {
                directives: [{ name: "waves", rawName: "v-waves" }],
                staticClass: "filter-item",
                attrs: { type: "primary", disabled: _vm.saveButtonDisabled },
                on: {
                  click: function ($event) {
                    return _vm.save()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("button.save")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [{ name: "waves", rawName: "v-waves" }],
                staticClass: "filter-item",
                on: { click: _vm.close },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("button.back")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._t("moreButton"),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }